import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";

import api from "../../../api";

import { Row, Col } from 'reactstrap';

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput"

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            nombre: '',
            host: '',
            username: '',
            password: '',
            port:''
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetForm() {
        this.setState({
            nombre: '',
            host: '',
            username: '',
            password: '',
            port:''
        });
    }

    setSelects(data) {
        this.setState(() => ({
            nombre: data.nombre,
            host: data.host,
            username: data.username,
            password: data.password,
            port: data.port
        }));
    }


    render() {

        return (
            <ParadigmaModal
                getUrl={api.email.casillas.detail}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Casilla de Mail"}
                buttonTitle={"Ver"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
            >

                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Nombre"}
                            fieldName={"nombre"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.nombre}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Host"}
                            fieldName={"host"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.host}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Usuario"}
                            fieldName={"username"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.username}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Contraseña"}
                            fieldName={"password"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.password}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Puerto"}
                            fieldName={"port"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.port}
                            disabled={true}
                        />
                    </Col>
                </Row>

            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Config/Casillas/Detail.js